import styled from '@emotion/styled';
import SearchBarAlgolia from '@ep/components/SearchBar';
import theme from '@ep/theme';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import React from 'react';
interface SearchBarModalProps {
  open: boolean;
  onClose: () => void;
}

const StyledModal = styled(Modal)`
  margin-top: 1rem;
  display: flex;
  align-items: start;
  justify-content: center;
  overflow-y: scroll;
`;

const ModalContainer = styled.div`
  position: relative;
  width: 50%;
  border-radius: 1rem;
  padding: 1rem;
  background-color: ${theme.colors.white};
  \outline: none;
  ${theme.mediaQueries.mobileAndTablet} {
    width: 95%;
  }
`;

function SearchBarModal({ open, onClose }: SearchBarModalProps) {
  return (
    <StyledModal open={open} onClose={onClose} role="complementary">
      <Fade in={open}>
        <ModalContainer>
          <SearchBarAlgolia />
        </ModalContainer>
      </Fade>
    </StyledModal>
  );
}

export default SearchBarModal;
